/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Report_ProblemInputs */

const en_kindle_report_problem = /** @type {(inputs: Kindle_Report_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report a reading problem`)
};

const es_kindle_report_problem = /** @type {(inputs: Kindle_Report_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informar de un problema de lectura`)
};

/**
* | output |
* | --- |
* | "Report a reading problem" |
*
* @param {Kindle_Report_ProblemInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_report_problem = /** @type {((inputs?: Kindle_Report_ProblemInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Report_ProblemInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_report_problem(inputs)
	return en_kindle_report_problem(inputs)
});